import { makeStyles } from '@material-ui/core/styles'
import { green } from '@material-ui/core/colors'

export default makeStyles(theme => ({
  formControl: {
    marginTop: '30px'
  },
  btn: {
    marginRight: '20px'
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  valor: {
    margin: '20px 0'
  }
}))
